// Generated by CoffeeScript 1.12.7
(function () {
  require("./styles.less");

  require("./icons/favicon.png");

  require.context("./", true, /\.svg$/);
}.call(this));
